import React from 'react'
import Areavideo from './Areavideo'
import AreaField from './AreaField'
import Team from '../Team/Team'
import Video from '../Video/Video'
import Testimonials from '../Testimonials/Testimonials'
import Why from '../Why/Why'
import Touch from '../Touch/Touch'
import Appointment from '../Appointment/Appointment'

const PracticeArea = () => {
  return (
    <>
        <Areavideo/>
        <AreaField/>
      
        <Touch/>
       
    </>
  )
}

export default PracticeArea